(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-hero-track]');
    var slides = slider.querySelectorAll('[data-hero-slide]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var total = slides.length;
    if (total < 2) {
      return;
    }

    var index = 0;
    var timer = null;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 5;

    function goTo(next) {
      index = (next + total) % total;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function start() {
      if (!autoplay) {
        return;
      }
      stop();
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, speed * 1000);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
        start();
      });
    });

    var startX = 0;
    var deltaX = 0;

    slider.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      deltaX = 0;
      stop();
    }, { passive: true });

    slider.addEventListener('touchmove', function (event) {
      deltaX = event.touches[0].clientX - startX;
    }, { passive: true });

    slider.addEventListener('touchend', function () {
      if (Math.abs(deltaX) > 40) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      }
      start();
    });

    goTo(0);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'theme_wishlist';

    function readWishlist() {
      try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    function writeWishlist(list) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    var saved = readWishlist();

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');

      if (saved.indexOf(handle) !== -1) {
        button.setAttribute('aria-pressed', 'true');
      }

      button.addEventListener('click', function () {
        var list = readWishlist();
        var index = list.indexOf(handle);

        if (index === -1) {
          list.push(handle);
          button.setAttribute('aria-pressed', 'true');
        } else {
          list.splice(index, 1);
          button.setAttribute('aria-pressed', 'false');
        }

        writeWishlist(list);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-store-availability"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-type="mobile-store-availability"]').forEach(function (root) {
    var locateBtn = root.querySelector('[data-nsl-locate]');
    var statusEl = root.querySelector('[data-nsl-status]');
    var searchEl = root.querySelector('[data-nsl-search]');
    var list = root.querySelector('[data-nsl-list]');
    var mapWrap = root.querySelector('.nsl__mapwrap');
    var mapFrame = root.querySelector('[data-nsl-map]');
    var sheet = root.querySelector('[data-nsl-sheet]');
    var stores = Array.prototype.slice.call(root.querySelectorAll('[data-nsl-store]'));

    var unit = root.getAttribute('data-unit') || 'km';
    var apiKey = root.getAttribute('data-api-key') || '';
    var autoLocate = root.getAttribute('data-auto') === 'true';

    function toRad(v) { return (v * Math.PI) / 180; }

    function distanceKm(la1, lo1, la2, lo2) {
      var R = 6371;
      var dLat = toRad(la2 - la1);
      var dLon = toRad(lo2 - lo1);
      var s1 = Math.sin(dLat / 2);
      var s2 = Math.sin(dLon / 2);
      var a = s1 * s1 + Math.cos(toRad(la1)) * Math.cos(toRad(la2)) * s2 * s2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function setStatus(msg) { if (statusEl) { statusEl.textContent = msg; } }

    function updateMap(lat, lng) {
      if (!mapFrame) { return; }
      if (apiKey) {
        mapFrame.src = 'https://www.google.com/maps/embed/v1/place?key=' + encodeURIComponent(apiKey) + '&q=' + lat + ',' + lng;
      } else {
        mapFrame.src = 'https://maps.google.com/maps?q=' + lat + ',' + lng + '&z=14&output=embed';
      }
    }

    function starSvg(on) {
      return '<svg viewBox="0 0 24 24" width="14" height="14" class="nsl__star' + (on ? ' is-on' : '') + '"><polygon points="12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9"></polygon></svg>';
    }

    // Fill the bottom card from a store element and centre the map on it.
    // Pass compact = true to show the small name + distance + directions
    // card used after auto-detecting the visitor's location; omit/false
    // for the full card (used on load and when a store is tapped).
    function setActive(el, compact) {
      if (!sheet || !el) { return; }
      var q = function (sel) { return sheet.querySelector(sel); };
      q('[data-sheet-name]').textContent = el.getAttribute('data-name') || '';
      q('[data-sheet-addr]').textContent = (el.getAttribute('data-address') || '').replace(/\s*\n\s*/g, ', ');

      var rating = parseFloat(el.getAttribute('data-rating'));
      var starsEl = q('[data-sheet-stars]');
      var rnum = q('[data-sheet-rating]');
      var rcount = q('[data-sheet-reviews]');
      if (!isNaN(rating)) {
        var r = Math.round(rating), html = '';
        for (var i = 1; i <= 5; i++) { html += starSvg(i <= r); }
        starsEl.innerHTML = html;
        rnum.textContent = el.getAttribute('data-rating');
        var rv = el.getAttribute('data-reviews');
        rcount.textContent = rv ? ('(' + rv + ')') : '';
      } else {
        starsEl.innerHTML = ''; rnum.textContent = ''; rcount.textContent = '';
      }

      var openEl = q('[data-sheet-open]');
      var isOpen = el.getAttribute('data-open') === '1';
      var hours = el.getAttribute('data-hours') || '';
      openEl.className = 'nsl__open nsl__open--' + (isOpen ? 'yes' : 'no');
      openEl.innerHTML = '<span class="nsl__open-dot"></span>' + (isOpen ? 'Open now' : 'Closed') + (compact ? '' : (hours ? (' · ' + hours) : ''));

      var distEl = q('[data-sheet-dist]');
      if (el._nslDistText) { distEl.textContent = el._nslDistText; distEl.hidden = false; }
      else { distEl.hidden = true; }

      var dir = el.getAttribute('data-dir');
      var btn = q('[data-sheet-dir]');
      if (dir) { btn.href = dir; btn.style.display = ''; } else { btn.style.display = 'none'; }

      sheet.classList.toggle('nsl__sheet--compact', !!compact);
      sheet.hidden = false;
      if (mapWrap) {
        mapWrap.classList.add('nsl__mapwrap--has-sheet');
        mapWrap.classList.toggle('nsl__mapwrap--compact-sheet', !!compact);
      }
      updateMap(el.getAttribute('data-lat'), el.getAttribute('data-lng'));
      stores.forEach(function (s) { s.classList.toggle('nsl__store--nearest', s === el); });
    }

    // Tap a store in the list to feature it in the full card.
    stores.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('a')) { return; }
        setActive(el, false);
        if (mapWrap) { mapWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      });
    });

    // Live filter by typed text
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        var qv = searchEl.value.trim().toLowerCase();
        stores.forEach(function (el) {
          var key = (el.getAttribute('data-search') || '').toLowerCase();
          el.style.display = (!qv || key.indexOf(qv) !== -1) ? '' : 'none';
        });
      });
    }

    function locate() {
      if (!navigator.geolocation) { setStatus('Location is not supported on this device.'); return; }
      setStatus('Finding stores near you…');
      if (locateBtn) { locateBtn.setAttribute('disabled', 'disabled'); }

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var uLat = pos.coords.latitude, uLng = pos.coords.longitude, withCoords = [];
          stores.forEach(function (el) {
            var lat = parseFloat(el.getAttribute('data-lat'));
            var lng = parseFloat(el.getAttribute('data-lng'));
            var distEl = el.querySelector('[data-nsl-dist]');
            if (isNaN(lat) || isNaN(lng)) { if (distEl) { distEl.hidden = true; } return; }
            var km = distanceKm(uLat, uLng, lat, lng);
            el._nslDist = km;
            var shown = unit === 'mi' ? km * 0.621371 : km;
            el._nslDistText = shown.toFixed(1) + ' ' + unit + ' away';
            if (distEl) { distEl.textContent = el._nslDistText; distEl.hidden = false; }
            withCoords.push(el);
          });

          if (!withCoords.length) {
            setStatus('No store coordinates set.');
            if (locateBtn) { locateBtn.removeAttribute('disabled'); }
            return;
          }

          withCoords.sort(function (a, b) { return a._nslDist - b._nslDist; });
          withCoords.forEach(function (el) { list.appendChild(el); });
          // Auto-detected location gets the compact card so the map stays
          // front and center; tapping any store still opens the full one.
          setActive(withCoords[0], true);
          setStatus('Showing the store nearest to you.');
          if (locateBtn) { locateBtn.removeAttribute('disabled'); }
        },
        function () {
          setStatus('Couldn’t get your location. Showing all stores.');
          if (locateBtn) { locateBtn.removeAttribute('disabled'); }
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
      );
    }

    if (locateBtn) { locateBtn.addEventListener('click', function () { locate(); }); }

    // Feature the first store immediately (full card), then auto-detect
    // location if enabled (switches to the compact card once found).
    if (stores.length) { setActive(stores[0], false); }
    if (autoLocate) { locate(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
